<template>
	<!-- 维护 -->
	<div>
		<div class="maintain" v-if="isMfrz">
<!--			<img src="../../src/assets/service.jpg" class="weihu">-->
      <img src="../../static/images/weihu.png" class="weihu">
      <h2>正在维护敬请期待</h2>
			<span>为了您更好的体验我们正在研发进行中</span>
			<button><img src="../../static/images/close.png" class="close" @click="close"></button>
		</div>
	</div>
</template>
<script>
	export default {
		props:['isMfrz'],
		data () {
			return {

			}
		},
		methods:{
			close(){
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
.maintain{position: fixed;top: 50%;left: 50%;width: 4rem;height: 3.32rem;background-color: #FFFFFF;box-shadow:0rem .04rem .49rem .01rem rgba(216,218,221,0.5);margin-left: -2rem;margin-top: -1.66rem;text-align: center;z-index: 6666;}
.maintain .weihu{width:2.35rem;height:1.34rem;margin: .39rem auto 0;display: block;}
.maintain .close{width: .17rem;height: .17rem;position: absolute;top: .17rem;right: .17rem;}
.maintain .close img{width: 100%;}
.maintain h2{font-size: .26rem;font-weight: bold;margin-top: .37rem;}
.maintain span{color: #666666;font-size: .16rem;display: block;width: 2.75rem;margin: .3rem auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
</style>



// WEBPACK FOOTER //
// src/components/maintain.vue